import { Button, Col, Row } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft, faFilePdf } from '@fortawesome/free-solid-svg-icons';
import { useReactToPrint } from 'react-to-print';

import { useRef } from 'react';

//Estilo da pagina de impressão
const pageStyle = `
@page { 
  size: auto;  margin: 0mm ;
} 
@media print { 
    body { -webkit-print-color-adjust: exact; } 
}
@media print {
  @page{
    size:A4;
    margin:0;
  }
  .relatorio {
    width: 100vw!important;
    display:flex;
    flex-direction:column;
  }
  div.header{
    display:table-header-group;
  }
  div.body{
    display:table-row-group;
  }
  .noPrint{
    display: none;
  }
}
`;


function DocumentoPersonalizado({ documento, handleVoltar }) {

  //Referencia para o componente de impressão
  const ref = useRef(null);

  //Função assionada assim que do botão de imprimir pdf é clicado
  const handlePrint = useReactToPrint({
    content: () => ref.current,
    copyStyles: true,
    documentTitle: "ModeloDocumentoEnvio",
    pageStyle: pageStyle
  });

  return <>
    <div>
      <Row className='d-flex justify-content-between align-items-center'>
        <Col md={6} lg={6} className='text-start px-3'>
          <Button
            onClick={handleVoltar}
          >
            <FontAwesomeIcon icon={faAngleLeft} className='me-2' /> Voltar
          </Button>
        </Col>
        <Col md={6} lg={6} className='text-end px-5 m-0'>
          <Button color='danger' onClick={handlePrint}>
            <FontAwesomeIcon icon={faFilePdf} /> Imprimir
          </Button>
        </Col>
      </Row>
    </div>
    <Row className='px-4'>
      <div className={`bg-white p-3 mt-3 rounded shadow `} ref={ref}>
        <div className='bw-bold d-flex justify-content-center align-items-center flex-column mb-2'>
          <h4 style={{ color: "#666" }}>Modelo de documento {documento?.identificacao}</h4>
        </div>
        <div dangerouslySetInnerHTML={{ __html: documento?.html }}>

        </div>
      </div>
    </Row>
  </>;
}

export default DocumentoPersonalizado;